module.exports = __webpack_public_path__ + "img/1.f86227d7.png";